import React from 'react';
import './Checkoutadvertisement.css';
import { useStateValue } from './StateProvider';
function Checkoutadvertisement(props) {
 
    const[{user,basket},dispatch]=useStateValue();

    const addToBasket = (event)=>{
       event.preventDefault();
       dispatch({
           type:'ADD_TO_BASKET',
           item: {
            id: props.id,
            title: props.title,
            image: props.image,
            price: props.price,
            rating: props.rating,
          },
       })
    }

  return <div className='checkoutadvertisement'>
   <div className='checkoutadvertisement__container'>
   <div className='image__container'>
    <img className='image' src={props.image} />
   </div>
   <div className='info'>
    <p className='title'>{props.title}</p>
    <p className='rating'>{Array(props.rating)
                    .fill()
                    .map((_, i) => (
                        <p>🌟</p>
                    ))}</p>
    <p className='price'>${props.price}</p>
    <button className='btn btn-outline-warning button' onClick={addToBasket}>Add to Basket</button>
   </div>
  </div>;
  </div>
}

export default Checkoutadvertisement;
